export class BadResultError extends Error {

  name = "BadResultError";

  constructor(message, code) {
    super(message);
    this.code = code;
  }

  static CODE_NSFW = "nsfw";
  static CODE_KEYPOINTS_BLOCKED = "keypoints_blocked";
  static CODE_MULTIFACE_RESULT = "multiface_result";
  static CODE_POSITION = "position";
  static CODE_UNKNOWN_CELEBRITY = "unknown_celebrity";

  static keypointsBlocked(message) {
    return new BadResultError(message || "Keypoints is blocked", BadResultError.CODE_KEYPOINTS_BLOCKED);
  }

  static nsfw(message) {
    return new BadResultError(message || "NSFW", BadResultError.CODE_NSFW);
  }

  static multifaceResult(message) {
    return new BadResultError(message || "Multiface", BadResultError.CODE_MULTIFACE_RESULT);
  }

  static position(message) {
    return new BadResultError(message || "Invalid position", BadResultError.CODE_POSITION);
  }

  static celebrity(message) {
    return new BadResultError(message || "Unknown Celebrity", BadResultError.CODE_UNKNOWN_CELEBRITY);
  }
}
